import { apiUrl, apiUrl2, local_Api_Url2 } from '../../../settings'
import { Api_Url2 } from '../../../api'

export const addContractUrl = () => {
  return apiUrl + '/api/contract'
}

export const getAllContracts = () => {
  return apiUrl + '/api/contract'
}

export const getContractWithUrl = () => {
  return apiUrl + '/api/group-by-contract-with'
}

export const getsingleContractUrl = () => {
  return apiUrl + '/api/single-contract'
}

export const updateContractUrl = () => {
  return apiUrl + '/api/update-contract'
}

export const addPendingUniContractUrl = () => {
  return Api_Url2 + '/pending-uni-contract/add'
}
export const getAllPendingContractsUrl = () => {
  return Api_Url2 + '/pending-uni-contract/getAll'
}
export const getContractWithListUrl = () => {
  return apiUrl + '/api/get-contract-with-list'
}
export const editPendingUniContractUrl = () => {
  return Api_Url2 + '/pending-uni-contract/edit'
}
export const updateContractStatusUrl = () => {
  return apiUrl + '/api/delete-contact'
}

